import { buildUrl } from '../../../utils/api';

export const fetchUserURL = (id: number) => buildUrl(`/api/v3/adm/user/${id}`);

export const fetchAuditLogURL = (id: number) =>
  buildUrl(`/api/v2/adm/auditlog/events/login?user_id=${id}`);
